import React, { useEffect, useState, useMemo } from "react"
import { endpointGetConversions, endpointAdminRemoveConversion, urlConversion } from "../services/Endpoints";
import AuthService from "../services/AuthService";
import { Loading } from "./Loading";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import Paginator from "./Paginator";
import ConversionModal from "./ConversionModal";
import ConversionDetailModal from "./ConversionDetailModal";
import ConfirmationModal from "./ConfirmationModal";
import { ActionsMenu } from "./AccountsUsers/ActionsMenu";

export function ConversionList({ filters, refreshKey }) {

    const [loading, setLoading] = useState(false);
    const [projects, setProjects] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [selectedProjectDetail, setSelectedProjectDetail] = useState(null);
    const [confirmDelete, setConfirmDelete] = useState({ isOpen: false, project: null, isLoading: false });
    const itemsPerPage = 10;
    const navigate = useNavigate();

    useEffect(() => {
        getConversions();
        return () => {
            setProjects(() => [])
        }
    }, [refreshKey]);

    const handleClickOpenConversion = (project) => {
        setSelectedProject(project);
        setIsModalOpen(true);
    }

    const handleOpenDetail = (project) => {
        setSelectedProjectDetail(project);
        setIsDetailOpen(true);
    }

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedProject(null);
    }

    const handleUploadSuccess = async () => {
        setIsModalOpen(false);
        await getConversions();
    }

    const handleAskDelete = (project) => {
        setConfirmDelete({ isOpen: true, project, isLoading: false });
    }

    const handleCloseDelete = () => {
        setConfirmDelete({ isOpen: false, project: null, isLoading: false });
    }

    const handleConfirmDelete = async () => {
        const project = confirmDelete.project;
        if (!project) return;
        try {
            setConfirmDelete(prev => ({ ...prev, isLoading: true }));
            const token = AuthService.getToken();
            const response = await fetch(`${urlConversion}${endpointAdminRemoveConversion}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ ink_id: project.ink_id, account: project.account })
            });
            const res = await response.json();
            if (res && res.status == 'success') {
                setConfirmDelete({ isOpen: false, project: null, isLoading: false });
                await getConversions();
            } else {
                setConfirmDelete(prev => ({ ...prev, isLoading: false }));
            }
        } catch (error) {
            setConfirmDelete(prev => ({ ...prev, isLoading: false }));
        }
    }

    const getConversions = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${urlConversion}${endpointGetConversions}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const res = await response.json();
            if (res && res.status == 'success') {
                setProjects(res.data.projects);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const filteredProjects = useMemo(() => {
        let result = projects.filter(project => {
            const matchStatus = statusFilter === '' || String(project.status) === statusFilter;
            const matchAccount = filters.account === '' || project.account.toLowerCase().includes(filters.account.toLowerCase());
            const matchInkId = filters.ink_id === '' || String(project.ink_id).toLowerCase().includes(filters.ink_id.toLowerCase());
            return matchStatus && matchAccount && matchInkId;
        });

        // Ordenar: Nuevo (0) -> Pendiente (2) -> Terminado (1)
        const orderMap = { '0': 1, '2': 2, '1': 3 };
        result.sort((a, b) => {
            return (orderMap[String(a.status)] || 99) - (orderMap[String(b.status)] || 99);
        });

        return result;
    }, [projects, filters, statusFilter]);

    const paginatedProjects = useMemo(() => {
        const offset = (currentPage - 1) * itemsPerPage;
        return filteredProjects.slice(offset, offset + itemsPerPage);
    }, [filteredProjects, currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <>
            {loading == true &&
                <Loading />
            }

            <div className="row mb-3 mt-4">
                <div className="col-md-4 col-lg-3">
                    <label className="fw-bold mb-2 small text-uppercase text-white opacity-75">Estado de Conversión</label>
                    <div className="d-flex gap-2">
                        <select
                            className="form-select bg-dark text-white border-secondary py-2"
                            value={statusFilter}
                            onChange={(e) => {
                                setStatusFilter(e.target.value);
                                setCurrentPage(1);
                            }}
                        >
                            <option value="">Todos los estados</option>
                            <option value="0">Nuevo</option>
                            <option value="2">En proceso</option>
                            <option value="1">Terminado</option>
                        </select>
<button
                            className="btn btn-ink-icon"
                            onClick={() => getConversions()}
                            title="Recargar lista"
                        >
                            <FontAwesomeIcon icon={faSync} spin={loading} />
                        </button>
                    </div>
                </div>
            </div>
            <div className="modern-table-container">
                <table className="modern-table striped-table">
                    <thead>
                        <tr key={50000}>
                            <th>Info.</th><th>Cuenta</th><th>Ink id</th><th>Título</th><th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedProjects.length === 0 ? (
                            <tr>
                                <td colSpan="5" className="text-center py-5 text-white-50">
                                    <h6 className="m-0 opacity-50">No se encontraron resultados para los filtros aplicados</h6>
                                </td>
                            </tr>
                        ) : (
                            paginatedProjects.map((project, index) => {
                                let statusLabel = 'Pendiente';
                                if (String(project.status) === '1') { statusLabel = 'Terminado'; }
                                else if (String(project.status) === '0') { statusLabel = 'Nuevo'; }
                                else if (String(project.status) === '2') { statusLabel = 'En proceso'; }

                                const items = [
                                    { label: 'Ver', onClick: () => handleOpenDetail(project) },
                                ];
                                if (String(project.status) !== '1') {
                                    items.push({ label: 'Cargar conversión', onClick: () => handleClickOpenConversion(project) });
                                }
                                items.push({ label: 'Eliminar', onClick: () => handleAskDelete(project), danger: true });

                                return <tr key={project.id || `${project.account}-${project.ink_id}`} >
                                    <td className="short">
                                        <span className={`badge-status status-${project.status}`}>
                                            {statusLabel}
                                        </span>
                                    </td>

                                    <td className="short">{project.account}</td>
                                    <td className="short">{project.ink_id}</td>
                                    <td>{project.title}</td>
                                    <td>
                                        <ActionsMenu items={items} title="Acciones de la conversión" />
                                    </td>
                                </tr>
                            })
                        )}
                    </tbody>
                </table>
            </div>
            {filteredProjects.length > itemsPerPage && (
                <Paginator
                    totalItems={filteredProjects.length}
                    itemsPerPage={itemsPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            )}
            
            <ConversionModal 
                isOpen={isModalOpen} 
                onClose={handleCloseModal} 
                project={selectedProject}
                onSuccess={handleUploadSuccess}
            />

            <ConversionDetailModal
                isOpen={isDetailOpen}
                onClose={() => setIsDetailOpen(false)}
                project={selectedProjectDetail}
            />

            <ConfirmationModal
                isOpen={confirmDelete.isOpen}
                onClose={handleCloseDelete}
                onConfirm={handleConfirmDelete}
                title="Eliminar conversión"
                message={confirmDelete.project
                    ? `¿Seguro que deseas eliminar la conversión ${confirmDelete.project.account}-C-${confirmDelete.project.ink_id}? Se eliminarán también sus servicios (ISBN y portada). Esta acción no se puede deshacer.`
                    : ''}
                confirmText="Eliminar"
                cancelText="Cancelar"
                type="danger"
                isLoading={confirmDelete.isLoading}
            />
        </>
    )
}

export default ConversionList